import { useWebBillingHost } from './context';
import type { BillingSession } from './types';

/** The session of the host: the signed-in user and their permission codes. */
export function useAuth(): BillingSession {
  return useWebBillingHost().session.useAuth();
}
